import { Switch, Route, useRouteMatch, useHistory } from "react-router-dom";
import { ProgrammeProps } from "../Props";
import { useDispatch, useSelector } from "react-redux";
import { useEffect } from "react";
import { PowerOfTen, ProgressStepEnum, setStepProgress } from "../../../../redux/slices/progressBarSlice";
import OysHeadOfServiceChecker from "./OysHeadOfServiceChecker";
import { LoadingPage } from "../LoadingPage";

const LoadingScreen = () => {
  const history = useHistory();
  const pageData = useSelector(
    (state: any) => state.signupFlowData.signupPagesData?.["oys-head-of-service"]?.loadingScreen
  );

  return (
    <LoadingPage
      callback={() => history.replace("/almost-done")}
      heading={pageData?.title ?? ""}
      text={pageData?.body ?? ""}
      isLoading={false}
    />
  );
};

interface OysHeadOfServiceRootProps extends OysHeadOfServiceCheckerProps {
  progressPercentage?: PowerOfTen;
}

export interface OysHeadOfServiceCheckerProps extends ProgrammeProps {
  employmentStatus: string | null;
  isCarer: string | null;
}

function OysHeadOfServiceRoot(props: Readonly<OysHeadOfServiceRootProps>) {
  const { programmeTitle, progressPercentage } = props;
  const { path } = useRouteMatch();

  const dispatch = useDispatch();

  useEffect(() => {
    if (progressPercentage) {
      dispatch(
        setStepProgress({
          progressStepEnum: ProgressStepEnum.CheckEligiblity,
          progressPercentage: progressPercentage,
        })
      );
    }
  }, [dispatch, progressPercentage]);

  return (
    <Switch>
      <Route exact path={`${path}`}>
        <OysHeadOfServiceChecker {...props} />
      </Route>
      <Route path={`${path}/loading`} component={LoadingScreen} />
    </Switch>
  );
}

export default OysHeadOfServiceRoot;
